import { Image, Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import appstore from "../images/appstore.png";
import { AppStoreImage } from "../images/SVGs";
import DP from "../images/DollarPrice.jpg";
import Gold from "../images/GoldArabicCover.png";

function Download() {
  return (
    <Container style={{ margin: "5%" }} dir="rtl" lang="ar">
      <div className="centered-container">
        <div style={{ margin: "1%", width: "70%" }}>
          <h1>تحميل</h1>
          <img
            src={DP}
            style={{ width: "100%", marginTop: "5%", marginBottom: "1%" }}
          ></img>
          <br />
          <Button>سعر الدولار</Button>
          <a href="https://apps.apple.com/us/app/id1178902826">
            {" "}
            <AppStoreImage />
          </a>

          <img
            src={Gold}
            style={{ width: "100%", marginTop: "10%", marginBottom: "1%" }}
          ></img>
          <br />
          <Button variant="warning">سعر الذهب</Button>
          <a href="https://apps.apple.com/us/app/id6473786747">
            {" "}
            <AppStoreImage />
          </a>
        </div>
      </div>
    </Container>
  );
}

export default Download;
